var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VContainer',_vm._b({staticClass:"page-section page-section-image-break has-bg",style:(_vm.sectionStyles),attrs:{"fluid":"","px-0":"","my-0":"","fill-height":""}},'VContainer',_vm.allPropsAndAttrs,false),[_c('VFlex',[(!!_vm.title)?_c('h2',{class:_vm.titleClass || 'header-3 text-xs-center'},[_vm._v(_vm._s(_vm.title))]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }